export default __webpack_public_path__ + "static/media/sticker-j.112a42c0.png";